import kebabCase from 'lodash/kebabCase';
import React from 'react';

import {Badge, Icon} from '@albert-io/atomic';
import {ClassroomV1} from '@albert-io/models';

interface ClassroomFlairProps {
  isForAll: boolean;
  classroom?: ClassroomV1;
}

function getDomainClassName(classroom?: any): string {
  const subjects = classroom?.getSubjects?.();
  if (!subjects || subjects.isEmpty?.()) return 'background-brand';

  const sorted = subjects.sortBy?.((s) => s.getName?.()) ?? subjects;
  const firstSubject = sorted.first?.();
  const curriculumArea = firstSubject?.getCurriculumArea?.();

  if (!curriculumArea || curriculumArea.isEmpty?.()) return 'background-brand';

  const slug = kebabCase(curriculumArea.getName());
  return `background-domain-${slug}`;
}

export default function ClassroomFlair({isForAll, classroom}: ClassroomFlairProps) {
  if (isForAll) {
    return (
      <Badge
        className='mr-x1 p-x0-quarter'
        status='info'
        size='small'
        roundness='square'
        aria-hidden='true'
      >
        <Icon icon='home' iconStyle='regular' fixedWidth />
      </Badge>
    );
  }

  const initial = classroom?.getName?.()?.charAt(0).toUpperCase() ?? '';
  const domainClass = getDomainClassName(classroom);

  return (
    <Badge
      className={`mr-x1 ${domainClass} border-none content-primary-inverse-static font-bold! [&>.a-text]:leading-none`}
      size='small'
      roundness='circle'
      aria-hidden='true'
    >
      {initial}
    </Badge>
  );
}
